import { observer } from "mobx-react";
import { IBasicInfoBlock } from "netbank-shared/src/libs/models/Content/BasicInfoBlock";
import { IGenericContentLink } from "netbank-shared/src/libs/models/Content/ContentLink";
import React from "react";
import rootStyles from "../../../pages/Root.scss";
import styles from "./BasicInfoBlock.scss";
import { Notification } from "~views/shared/Notifications/Notification";

interface IBasicInfoBlockProps {
  key: string;
  data: IGenericContentLink<IBasicInfoBlock>;
  nextBlockType?: string;
  noBorder?: boolean;
  noBottomPadding?: boolean;
  inModal?: boolean;
}

export const BasicInfoBlock = observer(({ data, noBorder, noBottomPadding, inModal }: IBasicInfoBlockProps) => {
  const { level, header, textArea } = data;
  const classes = [styles.wrapper, styles.fullWidthNotification];

  if (!textArea) return null;

  if (noBorder) {
    classes.push(rootStyles.noBorder);
  }

  if (noBottomPadding) {
    classes.push(rootStyles.noBottomPadding);
  }

  if (inModal) {
    classes.push(styles.inModal);
  }

  return (
    <section className={classes.join(" ")}>
      <Notification level={level} header={header} content={textArea} />
    </section>
  );
});
